import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import CancelIcon from "@mui/icons-material/Cancel";
import Stack from "@mui/material/Stack";
import {Form, Formik, FormikValues} from "formik";
import * as Yup from "yup";
import {Box, Button, Container, Grid, Typography} from "@mui/material";
import {create} from "zustand";
import TextField from "../../FormsUI/TextField";
import {ModelButton, ModelClose, ModelContentText, ModelTitle, StatusIcon} from "../styles";
import Select from "../../FormsUI/Select";

type ConfirmWithDropdownDialogStore = {
    title: string;
    message: string;
    data: any;
    onSubmit?: (data: any, values: FormikValues) => void;
    // onSubmit?: (values: FormikValues) => object;
    confirmBtnDisable?: boolean,
    close: boolean;
    label: string;
    options : any[];
};

const useConfirmWithDropdownDialogStore = create<ConfirmWithDropdownDialogStore>((set) => ({
    title: "",
    message: "",
    data: undefined,
    onSubmit: undefined,
    checkBtnDisable: false,
    close: false,
    label: "",
    options : []
}));

export const openConfirmWithDropdownDialog = (
    title: string,
    message: string,
    data: any,
    label: string,
    options: any[],
    onSubmit?: (data: any, values: any) => void,
) => {
    useConfirmWithDropdownDialogStore.setState({
        title: title,
        message: message,
        data: data,
        onSubmit: onSubmit,
        confirmBtnDisable: false,
        close: true,
        label: label,
        options: options
    });
};

export const disableBtnConfirmWithCommentDialog = (val: boolean) => {
    useConfirmWithDropdownDialogStore.setState({
        confirmBtnDisable: val,
    });
};

export const closeConfirmWithDropdownDialog = () => {
    useConfirmWithDropdownDialogStore.setState({
        close: false,
    });
};

const ConfirmWithDropdownDialog: React.FC = () => {
    const {title, message, data, onSubmit, confirmBtnDisable, close, label, options} = useConfirmWithDropdownDialogStore();


    const INITIAL_FORM_STATE = {
        option: 1,
    };

    const FORM_VALIDATION = Yup.object().shape({
        option: Yup.string().required("Please Enter your comment here"),
    });

    const handleClose = () => {
        useConfirmWithDropdownDialogStore.setState({
            close: false,
        });
    };

    return (
        <Box>
            <Dialog
                open={close}
                onClose={handleClose}
                fullWidth={true}
                PaperProps={{
                    style: {borderRadius: 15},
                }}
            >
                <ModelClose
                    color="warning"
                    onClick={handleClose}
                >
                    <CancelIcon/>
                </ModelClose>
                <Container>
                    <Grid
                        container
                        style={{marginTop: "40px", justifyContent: "center"}}
                        direction="row"
                        >
                        <Grid item>
                            <StatusIcon color="warning">error</StatusIcon>
                        </Grid>
                    </Grid>
                </Container>
                <Formik
                    initialValues={{
                        ...INITIAL_FORM_STATE,
                    }}
                    validationSchema={FORM_VALIDATION}
                    onSubmit={(values) => {
                        if (onSubmit) {
                            onSubmit(data, values);
                        }
                    }}
                >
                    <Form>
                        <ModelTitle color="warning">{title}</ModelTitle>
                        <DialogContent style={{textAlign: "center"}}>
                            <ModelContentText>{message}</ModelContentText>

                            <Stack direction="row" margin={"15px 0px 15px 0px"}>
                                <Select
                                    name='option'
                                    options={options}
                                    label={label}
                                    customHandleChange={() => {
                                    }}
                                />
                            </Stack>
                        </DialogContent>
                        <DialogActions
                            style={{display: "flex", justifyContent: "center"}}
                        >
                            <ModelButton
                                onClick={handleClose}
                                variant="outlined"
                                color='primary'
                            >
                                Cancel
                            </ModelButton>
                            <Box style={{width: 10}}/>
                            <ModelButton
                                type="submit"
                                variant="contained"
                                color='primary'
                                disabled={confirmBtnDisable}
                            >
                                Confirm
                            </ModelButton>
                        </DialogActions>
                    </Form>
                </Formik>
            </Dialog>
        </Box>
    );
};

export default ConfirmWithDropdownDialog;
